var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"student-class__empty-tab-fallback"},[_vm._v(" Ops! Não há nada por aqui. ")])}
var staticRenderFns = []

export { render, staticRenderFns }